import { Box, Typography } from '@mui/material';

export const SectionTitle = ({ children }) => (
  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
    <Typography variant="h4" align="center" mt={1} mb={1} width={320}>
      {children}
    </Typography>
  </Box>
);
